export enum SharedQueryKeys {
  // Group
  GetGroupForDetails = "GetGroupForDetails",
  GetGroupContracts = "GetGroupContracts",
  GetGroupsLeanWithFilters = "GetGroupsLeanWithFilters",

  // User
  Logout = "Logout",
  GetGroupUsers = "GetGroupUsers",
  GetUsersWithFilter = "GetUsersWithFilters",
  GetLoggedInUserInfo = "GetLoggedInUserInfo",
  GetUser = "GetUser",
  LoginAsUser = "LoginAsUser",
  Login = "Login",
  LogoutAsUser = "LogoutAsUser",

  Config = "Config",
}
